
import { Vue, Options } from "vue-class-component";
import FireBase from "@/models/fire";
import Auth from "@/controller/auth";
import AddToHomeScreen from "@/components/a2hs/AddToHomeScreen.vue";
import TheFooter from "@/components/footer/TheFooter.vue";

FireBase.init();

const isAppAddedToHomeScreen = window.matchMedia("(display-mode: standalone)")
  .matches;

const isIOS: boolean =
  [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) ||
  // iPad on iOS 13 detection
  (navigator.userAgent.includes("Mac") && !!document.ontouchend);

@Options({
  components: {
    AddToHomeScreen,
    TheFooter
  }
})
export default class App extends Vue {
  isAppAddedToHomeScreen: boolean = isAppAddedToHomeScreen;
  isIOS = isIOS;

  get isLoginRegisterPage(): boolean {
    const routeName = this.$route.name;
    return routeName === "Login" || routeName === "Register";
  }

  created() {
    Auth.getFirebaseAuth().onAuthStateChanged((user) => {
      if (user) {
        Auth.setIsAuth(user.uid);
      } else {
        Auth.clearAuth();
        if (!this.isLoginRegisterPage) {
          this.$router.push({ name: "Login" });
        }
      }
    });
  }
}
